import { Col, Icon, Result, Row, Spin, Typography } from "antd";
import React, { useEffect, useState } from "react";
import * as uuid from 'uuid';
import DOMRenderer from "../../components/dom-rederer";
import { WidgetContext } from "../../context";
import { DataUtils } from "../../utilities";
import { PackageLoader } from "../home/package-loader";

const CAWebform: React.FC<any> = ({history, ...rest}) => {

    const [casemanagementUiUrl, setCasemanagementUiUrl] = useState<string>();
    const [YccCaWebFormWidget, setYccCaWebFormWidget] = useState<any>();
    const [componentId] = useState<string>(`caWebform-${uuid.v4()}`);

    useEffect(()=>{
       DataUtils.caWebformInit().get().then((response)=>{
        let caseManagementUrl = response.casemanagementUrl
        setCasemanagementUiUrl(caseManagementUrl.endsWith('/') ? caseManagementUrl.substr(0, caseManagementUrl.length - 1) : caseManagementUrl);
       }) .catch((err)=>{
        console.log(' unable to load '+JSON.stringify(err))
       })
    
    },[]);

    return (
        <>
            { casemanagementUiUrl ?
                <WidgetContext.Provider value={{ YccCaWebFormWidget, setYccCaWebFormWidget }} >
                    <PackageLoader
                        bundleUrl={`${casemanagementUiUrl}/widgets/ycc-ca-webform-widget/v1.0.0/bundle.js`}
                        packageName={"@yodlee/ycc-ca-webform-widget"}
                        contextValue={YccCaWebFormWidget}
                        contextSetter={setYccCaWebFormWidget}>
                        {
                                YccCaWebFormWidget?.CaWebForm?
                                    <DOMRenderer
                                        componentProps={{}}
                                        componentReference={YccCaWebFormWidget.CaWebForm}
                                        componentId={componentId}
                                    /> :
                                    <Result status={404} title="Not found" subTitle="Sorry, the page you are looking for does not exist." />
                        }
                    </PackageLoader>    
                </WidgetContext.Provider> :
                <Row type="flex" justify="center" align="middle" style={{ height: "100vh" }}>
                    <Col>
                        <Spin size="large" indicator={<Icon type="loading" />} />
                    </Col>
                </Row>
            }
        </>
    );
}

export default CAWebform;